(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atelier-whatsapp"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const panel = document.getElementById('AtelierWhatsApp');
    if (panel && panel.open) {
      panel.open = false;
      panel.querySelector('summary').focus();
    }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atelier-winter-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  function setupWinterPopup() {
    const popup = document.getElementById('AtelierWinterPopup');
    if (!popup || popup.dataset.initialized) return;
    popup.dataset.initialized = 'true';
    const storageKey = 'atelier961-winter-popup-2026';
    let seen = false;
    try { seen = sessionStorage.getItem(storageKey) === 'shown'; } catch (error) {}
    if (seen) return;
    popup.addEventListener('click', function (event) {
      if (event.target !== popup) return;
      const bounds = popup.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
    });
    setTimeout(function () {
      if (!popup.isConnected || popup.open || document.querySelector('dialog[open]')) return;
      popup.showModal();
      try { sessionStorage.setItem(storageKey, 'shown'); } catch (error) {}
    }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupWinterPopup, { once: true });
  else setupWinterPopup();
})();
  } catch(e) { console.error(e); }
})();

})();
